export default __webpack_public_path__ + "static/media/ff14.c5ddb57b.jpg";